import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';

export const ImageCarouselControl = ({ direction, onClick }: { direction: 'left' | 'right'; onClick: () => void }) => {
  return (
    <Box>
      <IconButton
        onClick={onClick}
        size="large"
        sx={{
          bgcolor: 'white',
          borderRadius: 2,
          color: 'black',
          fontWeight: 'bold',
        }}
      >
        {direction === 'left' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
    </Box>
  );
};
